<template>
    <div class="contain">
        <img class="imgs" src="../../../assets/c13/acne_01.jpg" />
        <img class="imgs" src="../../../assets/c13/acne_02.jpg" />
        <img class="imgs" src="../../../assets/c13/acne_03.jpg" />
        <img class="imgs pb_5" src="../../../assets/c13/acne_04.jpg" />
        <img class="imgs c13_ibtn_cta"  @click="goLink" src="../../../assets/c13/btn_floot_cta_m.png" />
    </div>
</template>

<script>
export default {
    name: 'c13',
    methods: {
        goLink: function()
        {
            window.open('http://bit.ly/3Xq9OFI', '_blank')
        }
    }
}
</script>

<style scoped>
    .contain{
        width: 100%;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
    }
    .imgs  {
        width: 100%;
    }
    .pb_5{
        padding-bottom: 20px;
    }
    .c13_ibtn_cta{
        position: fixed;
        bottom: 10px;
        width: auto;
        max-width: 100%;
        z-index: 10;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_view/contents/c13.vue